import type { TLandRelation } from '../../../../../../types/api';

export const NEAR_LAND = 1 as TLandRelation;

export const locationInfoMessages = {
  noDatasetFound: "'No dataset found (point is outside of coverage)'",
  waterDepth: 'Water depth [mMSL]',
  gridCellSize: 'Grid cell size [m]',
  closeToLand: 'This point is close to land',
  pointOutOfGrid: 'Point is outside model grid',
  closeToLandTooltip:
    'We recommend choosing a point that is located more than two grid cells from land. You can move the point by drag-and-drop or by changing the coordinates. Note that the model grid may not include local land features such as islands, shoals, or ports.',
};
